<template>
  <span
    :class="[
      'inline-flex items-center gap-1.5 rounded-full font-semibold border',
      size === 'small' ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs',
      quantity > 0 ? 'bg-emerald-50 text-emerald-700 border-emerald-200' : 'bg-blue-50 text-blue-700 border-blue-200',
    ]"
  >
    <span
      :class="[
        'rounded-full flex-shrink-0',
        size === 'small' ? 'w-1 h-1' : 'w-1.5 h-1.5',
        quantity > 0 ? 'bg-emerald-500' : 'bg-blue-500',
      ]"
    ></span>
    {{ quantity > 0 ? t('product.inStock') : t('product.available') }}
  </span>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

defineProps({
  quantity: { type: Number, required: true },
  size: { type: String, default: 'default' },
})

const { t } = useI18n({ useScope: 'global' })
</script>
